import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { calculatePrice, formatDisplayPrice } from "../../utils/priceHandler";

const ProductPrice = ({ price, isSubscribed, quantity = 1, className = "" }) => {
  const submittedPromoCodes = useSelector(state => state.cart.submittedPromoCodes);
  const finalPrice = calculatePrice(price, quantity, isSubscribed, submittedPromoCodes);

  return (
    <div className={`product-price ${className}`}>
      <span className="text-mid">{formatDisplayPrice(finalPrice)}</span>

      {(finalPrice < price * quantity || isSubscribed) && (
        <span className="ml-2 text-sm text-gray-500 line-through">
          {formatDisplayPrice(price * quantity)}
        </span>
      )}
    </div>
  );
};

ProductPrice.propTypes = {
  price: PropTypes.number.isRequired,
  isSubscribed: PropTypes.bool,
  quantity: PropTypes.number,
  className: PropTypes.string,
};

export default ProductPrice;
